import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = { class: "job-listing-area pt-120 mb-120" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row mb-5" }
const _hoisted_9 = { class: "col-lg-12" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "col-lg-12" }
const _hoisted_12 = { class: "form-wrapper" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-inner mb-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Your Name*", -1)
const _hoisted_17 = { class: "input-area" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-inner mb-25" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1)
const _hoisted_22 = { class: "input-area" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/email-2.svg",
  alt: ""
}, null, -1)
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-inner mb-25" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "phonenumber" }, "Phone*", -1)
const _hoisted_27 = { class: "input-area" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/phone-2.svg",
  alt: ""
}, null, -1)
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-inner mb-25" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "jobplace" }, "Company Name (Optional)", -1)
const _hoisted_32 = { class: "input-area" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_34 = { class: "col-md-12" }
const _hoisted_35 = { class: "form-inner mb-40" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Address", -1)
const _hoisted_37 = { class: "col-md-12" }
const _hoisted_38 = { class: "form-inner" }
const _hoisted_39 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Charity Partner", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", { innerHTML: _ctx.cmsPageInfo }, null, 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "name",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.charityForm.name) = $event)),
                        placeholder: "Mr. Jackson Mile"
                      }, null, 512), [
                        [_vModelText, _ctx.charityForm.name]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "email",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.charityForm.email) = $event)),
                        placeholder: "info@example.com"
                      }, null, 512), [
                        [_vModelText, _ctx.charityForm.email]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "phonenumber",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.charityForm.phone) = $event)),
                        placeholder: "+880-17 *** *** **"
                      }, null, 512), [
                        [_vModelText, _ctx.charityForm.phone]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "jobplace",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.charityForm.company) = $event)),
                        placeholder: "Company Name"
                      }, null, 512), [
                        [_vModelText, _ctx.charityForm.company]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.charityForm.address) = $event)),
                      id: "description",
                      placeholder: "Your company address"
                    }, null, 512), [
                      [_vModelText, _ctx.charityForm.address]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    (!_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.charityPartner && _ctx.charityPartner(...args))),
                          class: "primry-btn-2 lg-btn w-unset",
                          type: "button"
                        }, "Become a Charity Partner"))
                      : (_openBlock(), _createElementBlock("button", _hoisted_39, _hoisted_42))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}